import React from 'react';
import OptionsResult from './OptionsResult';
import { withChartSettings } from './withChartSettings';

const ThemeResult = ({ question, segments, addToReport, chartSettings, ...props }) => {
  const themeSegments = segments.filter(segment => segment.themes?.length).map(segment => ({
    ...segment,
    values: segment.themes.map(tag => ({ name: tag.text, value: tag.count })),
  }));

  return (
    <OptionsResult
      {...props}
      question={{
        ...question,
        segments: themeSegments,
        translateNames: false,
      }}
      chartSettings={withChartSettings(chartSettings, 'bar')}
      toolbox={{
        chartTypes: ['bar', 'pie', 'stacked'],
      }}
      addToReport={addToReport && ((data) => {
        addToReport({
          chartSettings: {
            ...data?.chartSettings,
            fieldResultType: 'theme',
          },
        });
      })}
    />
  );
};

export default ThemeResult;
